module.exports = __webpack_public_path__ + "static/media/checkmark-circle-2.776cc1cc.svg";